<div class="history-view">
  <div class="history-header-block">
    <div class="history-filter-container">
      <div class="search">
        <app-search
          placeholder="Pesquise pelo nome do responsável ou do aluno"
          (search)="handleSearch($event)"
          [actionButton]="true"
          [statusDisabled]="isControlsEnabled(isSearched, monitorHistory)"
        ></app-search>
      </div>
      <div class="history-filter">
        <mat-paginator
          hidePageSize="true"
          [pageIndex]="pageIndex"
          [length]="searchQuery.length"
          [pageSize]="searchQuery.limit"
          aria-label="Select page"
          (page)="handlePageEvent($event)"
        >
        </mat-paginator>
        <button
          mat-button
          class="history-filter-button"
          (click)="filterHistory()"
          [disabled]="isControlsEnabled(isFiltered, monitorHistory)"
        >
          Filtros <mat-icon>tune</mat-icon>
        </button>
      </div>
    </div>

    <div
      *ngIf="!mobile && monitorGroupedHistory.length > 0"
      class="history-header"
    >
      <div class="header-col">Responsável</div>
      <div class="header-col">Aluno</div>
      <div class="header-col">Autorização</div>
      <div class="header-col">Funcionário</div>
      <div class="header-col small-col"></div>
    </div>
  </div>

  <div class="history-results">
    <div *ngIf="monitorGroupedHistory.length > 0; else noHistory">
      <div *ngFor="let groupHistory of monitorGroupedHistory">
        <div class="title">{{ groupHistory.date }}</div>

        <div class="gates-history">
          <app-card-arrival-history
            [gatesMonitor]="hist"
            *ngFor="let hist of groupHistory.gatesMonitor"
          ></app-card-arrival-history>
        </div>
      </div>
    </div>
    <ng-template #noHistory>
      <app-empty-list
        [imagePath]="
          isFiltered || isSearched
            ? '../../../../../assets/images/no-results.svg'
            : '../../../../../assets/images/no-arrival.svg'
        "
        [titleText]="isFiltered ? 'Nenhum resultado encontrado' : 'Oops!'"
        [articleText]="
          isFiltered || isSearched
            ? 'Busque por algum outro termo ou utilize um filtro diferente'
            : 'Nenhum aluno foi liberado nesta portaria ainda'
        "
      ></app-empty-list>
    </ng-template>
  </div>
</div>
